<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDeleteCustomer } from '../../../model/list/modal-delete-customer.hook'

defineOptions({
  name: 'ModalDeleteCustomer',
})

const {
  refIsOpen,
  refIsLoading,
  closeModal,
  confirmDelete,
} = useModalDeleteCustomer()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete customer?"
    detail="Are you sure you want to delete this customer? All of data will be permanently removed. This action cannot be uncompleted."
    button-title="Delete customer"
    @click:confirm="confirmDelete"
    @click:cancel="closeModal"
  />
</template>
